import { MdelloAdminClient } from 'mdello-client-ts';
import { LocalStorageKey } from 'src/localStorage/enums/localStorageKey.enum';

let client: MdelloAdminClient | null = null;

export const init = () => {
  const sessionId: string | null = localStorage.getItem(LocalStorageKey.SESSION_ID);
  if (client || !sessionId) {
    return client;
  }
  client = new MdelloAdminClient({ sessionId });
};

export const getClient = () => {
  return client;
};
